import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { getMsalInstance } from "../../services/authService";

const MsalProviderHost: React.FC = ({ children }) => {
    // Important: This component must be a child of `<AppConfigProvider />`, 
    // so that MSAL configuration is readily available when calling `getMsalInstance()`.
    const msalInstance = getMsalInstance();
    return (
        <MsalProvider instance={msalInstance}>
            {children}
        </MsalProvider>
    );
}

export default MsalProviderHost;